import { render } from "./AboutFeatures.vue?vue&type=template&id=72c26741&scoped=true"
import script from "./AboutFeatures.vue?vue&type=script&lang=js"
export * from "./AboutFeatures.vue?vue&type=script&lang=js"

import "./AboutFeatures.vue?vue&type=style&index=0&id=72c26741&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c26741"]])

export default __exports__